var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropdownBottom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.21967 5.21967C3.51256 4.92678 3.98744 4.92678 4.28033 5.21967L8.25 9.18934L12.2197 5.21967C12.5126 4.92678 12.9874 4.92678 13.2803 5.21967C13.5732 5.51256 13.5732 5.98744 13.2803 6.28033L8.78033 10.7803C8.48744 11.0732 8.01256 11.0732 7.71967 10.7803L3.21967 6.28033C2.92678 5.98744 2.92678 5.51256 3.21967 5.21967Z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#282D39"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownBottom);
export default __webpack_public_path__ + "static/media/dropdownBottom.b3cdb865001995be19cf5eecbcad5466.svg";
export { ForwardRef as ReactComponent };